import React from 'react';

import { QueryComponent } from '../../GraphQL';
import { useClassroomContext } from '../../Context/ClassroomContext';
import { classroomCourse } from '../../GraphQL/query/Classroom.query';
import { getMyExternalProfileInfo } from '../../GraphQL/query/MyProfile.query';
import { myCourse } from '../../GraphQL/query/Product.query';

export const getSectionCount = (sections = []) => {
  const sectionCount = sections.length;
  const subsectionCount = sections.reduce((acc, curr) => {
    const { subSections = [] } = curr || {};
    const subsectionCount = subSections.length;
    return acc + subsectionCount;
  }, 0);
  return { sectionCount, subsectionCount };
};

const ClassroomInformation = ({ children }) => {
  const { classroomCourseId, classroomTimeId, courseId, hasClassroomSession } =
    useClassroomContext();

  if (!hasClassroomSession) return children({});
  return (
    <QueryComponent query={getMyExternalProfileInfo}>
      {({ myExternalProfile }) => {
        const { providerName } = myExternalProfile || {};
        return (
          <QueryComponent
            query={classroomCourse}
            variables={{
              classroomCourseId,
              classroomTimeId,
              includeClassroomTime: classroomTimeId ? true : false,
            }}
            // fetchPolicy="cache-and-network"
          >
            {({ classroomCourse, classroomTime }) => {
              return (
                <QueryComponent query={myCourse} variables={{ courseId }}>
                  {({ myCourse }) => {
                    // title of course
                    const { title, totalVideoTime, instructors, classroomMode, tableOfContent } =
                      classroomCourse || {};

                    const sections = tableOfContent?.sections;

                    //sectionCount
                    const { sectionCount, subsectionCount } = getSectionCount(sections);

                    //instructor
                    const instructor =
                      instructors && instructors[0] ? instructors[0].name : undefined;

                    // coursePackage
                    const { classroomTimeInfo: { courseTitle, courseType } = {}, remainingTime } =
                      classroomTime || {};
                    const coursePackage = courseType === 'PACK' ? courseTitle : null;

                    // progress of course
                    const {
                      courseInfo: {
                        classroomProgress: { progressPercent, expiryDate },
                        courseCode,
                      },
                    } = myCourse || {};

                    return children({
                      title,
                      sections,
                      totalVideoTime,
                      providerName,
                      myExternalProfile,
                      coursePackage,
                      remainingTime,
                      courseTitle,
                      courseType,
                      instructor,
                      progressPercent: Math.floor(progressPercent ?? 0),
                      expiryDate,
                      sectionCount,
                      subsectionCount,
                      courseCode,
                      classroomMode,
                    });
                  }}
                </QueryComponent>
              );
            }}
          </QueryComponent>
        );
      }}
    </QueryComponent>
  );
};

export default ClassroomInformation;
